"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const react_1 = __importDefault(require("react"));
require("./index.scss");
const react_router_dom_1 = require("react-router-dom");
const clsx_1 = __importDefault(require("clsx"));
const Button = (props) => {
    const { mainColor = true, disabled = false, className, onClick, type, children, icon, iconAltText, typeLink, linkTo, onlyIcon, reverseIconPosition = false, isPlainButton = false, linkOnClick, submitType = 'submit', target = '_self', } = props;
    const classNames = (0, clsx_1.default)(mainColor ? 'main-color-set' : 'second-color-set', disabled && 'disabled', type, onlyIcon && 'only-icon');
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('button-component', className), "data-testid": "button-component" },
        !typeLink && !isPlainButton && (react_1.default.createElement("button", { className: classNames, disabled: disabled, type: submitType, onClick: !disabled ? onClick : () => { } },
            children,
            icon && (react_1.default.createElement("img", { src: icon, alt: iconAltText, className: (0, clsx_1.default)(reverseIconPosition && 'reverse-icon-position') })))),
        typeLink && (react_1.default.createElement(react_router_dom_1.Link, { to: linkTo ? linkTo : '#', className: classNames, onClick: linkOnClick, target: target },
            children,
            icon ? react_1.default.createElement("img", { src: icon, alt: iconAltText }) : null)),
        isPlainButton && (react_1.default.createElement("a", { href: linkTo, className: classNames }, children))));
};
exports.Button = Button;
